import { useGetIdentity } from "@refinedev/core";
import { Avatar, Layout, Tooltip } from "antd";
import type { AdminWhoami } from "../lib/staff-types";
import { ROLE_LABEL } from "../lib/staff-types";
import { tamsThemeColors } from "../theme";

export function AdminHeader() {
	const { data: identity } = useGetIdentity<
		AdminWhoami & { name?: string; email?: string | null }
	>();

	const email = identity?.email ?? identity?.name ?? "";
	const initial = (email.trim().charAt(0) || "A").toUpperCase();
	const roleLabel = identity?.role ? ROLE_LABEL[identity.role] : null;
	const tooltip =
		[email, roleLabel].filter(Boolean).join(" · ") || "アカウント";

	return (
		<Layout.Header className="admin-header">
			<Tooltip title={tooltip}>
				<Avatar
					size={36}
					style={{
						backgroundColor: tamsThemeColors.primary,
						color: tamsThemeColors.primaryForeground,
						fontWeight: 600,
						cursor: "default",
					}}
				>
					{initial}
				</Avatar>
			</Tooltip>
		</Layout.Header>
	);
}
